import { Center, Flex, Text } from "@mantine/core";

import LogoutButton from "../logout-button/logout-button";

export default function Footer({ collapsed }: { collapsed: boolean }) {
  return (
    <Flex>
      <Center w={collapsed ? "70px" : "210px"}>
        <LogoutButton showLabel={!collapsed} iconSize={collapsed ? 20 : 16} />
      </Center>

      <Flex gap="xl" align="center" flex={1} justify="center">
        <Text fz="xs" c="dimmed">
          نسخه ۱.۰ - آخرین بروزرسانی: آذر ماه ۱۴۰۴
        </Text>
        <Text fz="xs" c="dimmed">
          ۱۴۰۴ @ تمامی حقوق وی‌بوم برای گروه کسب و کار وندا محفوظ است.
        </Text>
      </Flex>
    </Flex>
  );
}
